module.exports = __webpack_public_path__ + "static/img/one.6429c995.gif";